import DashboardTypes from './dashboard.types';

/** ***************** GET DASHBOARD DETAILS START *********************** */
export const getDashboardCardDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_CARD_DETAILS_START,
	payload: getData,
});

export const getDashboardCardDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_CARD_DETAILS_SUCCESS,
	payload: successData,
});

export const getDashboardCardDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_CARD_DETAILS_FAILURE,
	payload: failureData,
});

export const getDashboardCardDetailsResponseResetStart = () => ({
	type: DashboardTypes.GET_DASHBOARD_CARD_DETAILS_RESPONSE_RESET,
});

export const getDashboardCardDetailsResponseChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_CARD_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET DASHBOARD DETAILS END *********************** */

/** ***************** REJECT MEMBER START *********************** */
export const rejectedMemberListStart = (getData: any) => ({
	type: DashboardTypes.REJECT_MEMBER_LIST_START,
	payload: getData,
});

export const rejectedMemberListSuccess = (successData: any) => ({
	type: DashboardTypes.REJECT_MEMBER_LIST_SUCCESS,
	payload: successData,
});

export const rejectedMemberListFailure = (failureData: any) => ({
	type: DashboardTypes.REJECT_MEMBER_LIST_FAILURE,
	payload: failureData,
});

export const rejectedMemberListResponseReset = () => ({
	type: DashboardTypes.REJECT_MEMBER_LIST_RESET,
});

export const rejectedMemberListResponseChanged = () => ({
	type: DashboardTypes.REJECT_MEMBER_LIST_CHANGED,
});
/** *****************  REJECT MEMBER END *********************** */

/** ***************** REJECT NOTES MEMBER START *********************** */
export const rejectNotesMemberStart = (getData: any) => ({
	type: DashboardTypes.REJECT_NOTES_MEMBER_LIST_START,
	payload: getData,
});

export const rejectNotesMemberSuccess = (successData: any) => ({
	type: DashboardTypes.REJECT_NOTES_MEMBER_LIST_SUCCESS,
	payload: successData,
});

export const rejectNotesMemberFailure = (failureData: any) => ({
	type: DashboardTypes.REJECT_NOTES_MEMBER_LIST_FAILURE,
	payload: failureData,
});

export const rejectNotesMemberReset = () => ({
	type: DashboardTypes.REJECT_NOTES_MEMBER_LIST_RESET,
});

export const rejectNotesMemberChanged = () => ({
	type: DashboardTypes.REJECT_NOTES_MEMBER_LIST_CHANGED,
});
/** *****************  REJECT NOTES MEMBER END *********************** */

/** ***************** GET DASHBOARD DETAILS LOAN TYPE START *********************** */
export const getDashboardDetailsLoanTypeStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_START,
	payload: getData,
});

export const getDashboardDetailsLoanTypeSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_SUCCESS,
	payload: successData,
});

export const getDashboardDetailsLoanTypeFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_FAILURE,
	payload: failureData,
});

export const getDashboardDetailsLoanTypeResponseResetStart = () => ({
	type: DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_RESPONSE_RESET,
});

export const getDashboardDetailsLoanTypeResponseChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_DETAILS_LOAN_TYPE_RESPONSE_CHANGED,
});
/** ***************** GET DASHBOARD DETAILS LOAN TYPE END *********************** */

/** ***************** GET LOAN DETAILS START *********************** */
export const getLoanDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_LOAN_DETAILS_START,
	payload: getData,
});

export const getLoanDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_LOAN_DETAILS_SUCCESS,
	payload: successData,
});

export const getLoanDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_LOAN_DETAILS_FAILURE,
	payload: failureData,
});

export const getLoanDetailsResponseResetStart = () => ({
	type: DashboardTypes.GET_LOAN_DETAILS_RESPONSE_RESET,
});

export const getLoanDetailsResponseChanged = () => ({
	type: DashboardTypes.GET_LOAN_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET LOAN DETAILS END *********************** */

/** ***************** GET LOAN INDEX DETAILS START *********************** */
export const getLoanIndexDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_LOAN_INDEX_DETAILS_START,
	payload: getData,
});

export const getLoanIndexDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_LOAN_INDEX_DETAILS_SUCCESS,
	payload: successData,
});

export const getLoanIndexDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_LOAN_INDEX_DETAILS_FAILURE,
	payload: failureData,
});

export const getLoanIndexDetailsResponseResetStart = () => ({
	type: DashboardTypes.GET_LOAN_INDEX_DETAILS_RESPONSE_RESET,
});

export const getLoanIndexDetailsResponseChanged = () => ({
	type: DashboardTypes.GET_LOAN_INDEX_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET LOAN INDEX DETAILS END *********************** */

/** ***************** GET PARTICULAR DATE DEMAND START *********************** */
export const getParticularDateDemandStart = (getData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_START,
	payload: getData,
});

export const getParticularDateDemandSuccess = (successData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_SUCCESS,
	payload: successData,
});

export const getParticularDateDemandFailure = (failureData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_FAILURE,
	payload: failureData,
});

export const getParticularDateDemandReset = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_RESET,
});

export const getParticularDateDemandChanged = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_CHANGED,
});
/** *****************  GET PARTICULAR DATE DEMAND END *********************** */

/** ***************** GET PARTICULAR DATE DEMAND INFO START *********************** */
export const getParticularDateDemandInfoStart = (getData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_START,
	payload: getData,
});

export const getParticularDateDemandInfoSuccess = (successData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_SUCCESS,
	payload: successData,
});

export const getParticularDateDemandInfoFailure = (failureData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_FAILURE,
	payload: failureData,
});

export const getParticularDateDemandInfoReset = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_RESET,
});

export const getParticularDateDemandInfoChanged = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_DEMAND_INFO_CHANGED,
});
/** *****************  GET PARTICULAR DATE DEMAND INFO END *********************** */

/** ***************** GET PARTICULAR DATE MEMBER ABSENT START *********************** */
export const getParticularDateMemberAbsentStart = (getData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_START,
	payload: getData,
});

export const getParticularDateMemberAbsentSuccess = (successData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_SUCCESS,
	payload: successData,
});

export const getParticularDateMemberAbsentFailure = (failureData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_FAILURE,
	payload: failureData,
});

export const getParticularDateMemberAbsentReset = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_RESET,
});

export const getParticularDateMemberAbsentChanged = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_MEMBER_ABSENT_CHANGED,
});
/** *****************  GET PARTICULAR DATE MEMBER ABSENT END *********************** */

/** ***************** GET PARTICULAR DATE COLLECTION START *********************** */
export const getParticularDateCollectionStart = (getData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_START,
	payload: getData,
});

export const getParticularDateCollectionSuccess = (successData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_SUCCESS,
	payload: successData,
});

export const getParticularDateCollectionFailure = (failureData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_FAILURE,
	payload: failureData,
});

export const getParticularDateCollectionReset = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_RESET,
});

export const getParticularDateCollectionChanged = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_CHANGED,
});
/** *****************  GET PARTICULAR DATE COLLECTION END *********************** */

/** ***************** GET PARTICULAR DATE COLLECTION INFO START *********************** */
export const getParticularDateCollectionInfoStart = (getData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_START,
	payload: getData,
});

export const getParticularDateCollectionInfoSuccess = (successData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_SUCCESS,
	payload: successData,
});

export const getParticularDateCollectionInfoFailure = (failureData: any) => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_FAILURE,
	payload: failureData,
});

export const getParticularDateCollectionInfoReset = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_RESET,
});

export const getParticularDateCollectionInfoChanged = () => ({
	type: DashboardTypes.GET_PARTICULAR_DATE_COLLECTION_INFO_CHANGED,
});
/** *****************  GET PARTICULAR DATE COLLECTION INFO END *********************** */

/** ***************** GET WEEK COLLECTION START *********************** */
export const getWeekCollectionStart = (getData: any) => ({
	type: DashboardTypes.GET_WEEK_COLLECTION_START,
	payload: getData,
});

export const getWeekCollectionSuccess = (successData: any) => ({
	type: DashboardTypes.GET_WEEK_COLLECTION_SUCCESS,
	payload: successData,
});

export const getWeekCollectionFailure = (failureData: any) => ({
	type: DashboardTypes.GET_WEEK_COLLECTION_FAILURE,
	payload: failureData,
});

export const getWeekCollectionReset = () => ({
	type: DashboardTypes.GET_WEEK_COLLECTION_RESET,
});

export const getWeekCollectionChanged = () => ({
	type: DashboardTypes.GET_WEEK_COLLECTION_CHANGED,
});
/** *****************  GET WEEK COLLECTION END *********************** */

/** ***************** GET WEEK YET TO COLLECTION START *********************** */
export const getWeekYTCollectionStart = (getData: any) => ({
	type: DashboardTypes.GET_WEEK_YT_COLLECTION_START,
	payload: getData,
});

export const getWeekYTCollectionSuccess = (successData: any) => ({
	type: DashboardTypes.GET_WEEK_YT_COLLECTION_SUCCESS,
	payload: successData,
});

export const getWeekYTCollectionFailure = (failureData: any) => ({
	type: DashboardTypes.GET_WEEK_YT_COLLECTION_FAILURE,
	payload: failureData,
});

export const getWeekYTCollectionReset = () => ({
	type: DashboardTypes.GET_WEEK_YT_COLLECTION_RESET,
});

export const getWeekYTCollectionChanged = () => ({
	type: DashboardTypes.GET_WEEK_YT_COLLECTION_CHANGED,
});
/** *****************  GET WEEK YET TO COLLECTION END *********************** */

/** ***************** GET ARREAR COLLECTION LIST START *********************** */
export const getArrearCollectionListStart = (getData: any) => ({
	type: DashboardTypes.ARREAR_COLLECTION_LIST_START,
	payload: getData,
});

export const getArrearCollectionListSuccess = (successData: any) => ({
	type: DashboardTypes.ARREAR_COLLECTION_LIST_SUCCESS,
	payload: successData,
});

export const getArrearCollectionListFailure = (failureData: any) => ({
	type: DashboardTypes.ARREAR_COLLECTION_LIST_FAILURE,
	payload: failureData,
});

export const getArrearCollectionListReset = () => ({
	type: DashboardTypes.ARREAR_COLLECTION_LIST_RESET,
});

export const getArrearCollectionListChanged = () => ({
	type: DashboardTypes.ARREAR_COLLECTION_LIST_CHANGED,
});
/** *****************  GET ARREAR COLLECTION LIST END *********************** */

/** ***************** DASHBOARD COLLECTION INFO START *********************** */
export const getDashboardCollectionNoteInfoStart = (getData: any) => ({
	type: DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_START,
	payload: getData,
});

export const getDashboardCollectionNoteInfoSuccess = (successData: any) => ({
	type: DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_SUCCESS,
	payload: successData,
});

export const getDashboardCollectionNoteInfoFailure = (failureData: any) => ({
	type: DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_FAILURE,
	payload: failureData,
});

export const getDashboardCollectionNoteInfoReset = () => ({
	type: DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_RESET,
});

export const getDashboardCollectionNoteInfoChanged = () => ({
	type: DashboardTypes.DASHBOARD_COLLECTION_NOTE_INFO_CHANGED,
});
/** *****************  DASHBOARD COLLECTION INFO END *********************** */

/** ***************** COMPANY EOD STATUS START *********************** */
export const companyEodStatusStart = (getData: any) => ({
	type: DashboardTypes.COMPANY_EOD_STATUS_START,
	payload: getData,
});

export const companyEodStatusSuccess = (successData: any) => ({
	type: DashboardTypes.COMPANY_EOD_STATUS_SUCCESS,
	payload: successData,
});

export const companyEodStatusFailure = (failureData: any) => ({
	type: DashboardTypes.COMPANY_EOD_STATUS_FAILURE,
	payload: failureData,
});

export const companyEodStatusResponseResetStart = () => ({
	type: DashboardTypes.COMPANY_EOD_STATUS_RESPONSE_RESET,
});

export const companyEodStatusResponseChanged = () => ({
	type: DashboardTypes.COMPANY_EOD_STATUS_RESPONSE_CHANGED,
});
/** ***************** COMPANY EOD STATUS END *********************** */

/** ***************** DASHBOARD PARTICULAR DETAILS START *********************** */
export const getDashboardParticularDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_START,
	payload: getData,
});

export const getDashboardParticularDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_SUCCESS,
	payload: successData,
});

export const getDashboardParticularDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_FAILURE,
	payload: failureData,
});

export const getDashboardParticularDetailsReset = () => ({
	type: DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_RESET,
});

export const getDashboardParticularDetailsChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_PARTICULAR_DETAILS_CHANGED,
});
/** *****************  DASHBOARD PARTICULAR DETAILS END *********************** */

/** ***************** GET DASHBOARD COLLECTION OFFICER START *********************** */
export const getDashboardStaffCollectionStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_START,
	payload: getData,
});

export const getDashboardStaffCollectionSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_SUCCESS,
	payload: successData,
});

export const getDashboardStaffCollectionFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_FAILURE,
	payload: failureData,
});

export const getDashboardStaffCollectionReset = () => ({
	type: DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_RESET,
});

export const getDashboardStaffCollectionChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_STAFF_COLLECTION_CHANGED,
});
/** *****************  GET DASHBOARD COLLECTION OFFICER END *********************** */

/** ***************** GET STAFF LOCATION START *********************** */
export const getStaffLocationStart = (getData: any) => ({
	type: DashboardTypes.GET_STAFF_LOCATION_START,
	payload: getData,
});

export const getStaffLocationSuccess = (successData: any) => ({
	type: DashboardTypes.GET_STAFF_LOCATION_SUCCESS,
	payload: successData,
});

export const getStaffLocationFailure = (failureData: any) => ({
	type: DashboardTypes.GET_STAFF_LOCATION_FAILURE,
	payload: failureData,
});

export const getStaffLocationReset = () => ({
	type: DashboardTypes.GET_STAFF_LOCATION_RESET,
});

export const getStaffLocationChanged = () => ({
	type: DashboardTypes.GET_STAFF_LOCATION_CHANGED,
});
/** *****************  GET STAFF LOCATION END *********************** */

/** ***************** GET SMS USED LIST START *********************** */
export const getSMSUsedListStart = (getData: any) => ({
	type: DashboardTypes.SMS_USED_LIST_START,
	payload: getData,
});

export const getSMSUsedListSuccess = (successData: any) => ({
	type: DashboardTypes.SMS_USED_LIST_SUCCESS,
	payload: successData,
});

export const getSMSUsedListFailure = (failureData: any) => ({
	type: DashboardTypes.SMS_USED_LIST_FAILURE,
	payload: failureData,
});

export const getSMSUsedListReset = () => ({
	type: DashboardTypes.SMS_USED_LIST_RESET,
});

export const getSMSUsedListChanged = () => ({
	type: DashboardTypes.SMS_USED_LIST_CHANGED,
});
/** *****************  GET SMS USED LIST END *********************** */

/** ***************** GET KYC USED LIST START *********************** */
export const getKYCUsedListStart = (getData: any) => ({
	type: DashboardTypes.KYC_USED_LIST_START,
	payload: getData,
});

export const getKYCUsedListSuccess = (successData: any) => ({
	type: DashboardTypes.KYC_USED_LIST_SUCCESS,
	payload: successData,
});

export const getKYCUsedListFailure = (failureData: any) => ({
	type: DashboardTypes.KYC_USED_LIST_FAILURE,
	payload: failureData,
});

export const getKYCUsedListReset = () => ({
	type: DashboardTypes.KYC_USED_LIST_RESET,
});

export const getKYCUsedListChanged = () => ({
	type: DashboardTypes.KYC_USED_LIST_CHANGED,
});
/** *****************  GET KYC USED LIST END *********************** */

/** ***************** DASHBOARD STAFF MAP COLLECTION START *********************** */
export const getDashboardStaffMapCollectionStart = (getData: any) => ({
	type: DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_START,
	payload: getData,
});

export const getDashboardStaffMapCollectionSuccess = (successData: any) => ({
	type: DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_SUCCESS,
	payload: successData,
});

export const getDashboardStaffMapCollectionFailure = (failureData: any) => ({
	type: DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_FAILURE,
	payload: failureData,
});

export const getDashboardStaffMapCollectionReset = () => ({
	type: DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_RESET,
});

export const getDashboardStaffMapCollectionChanged = () => ({
	type: DashboardTypes.DASHBOARD_STAFF_MAP_COLLECTION_CHANGED,
});
/** *****************  DASHBOARD STAFF MAP COLLECTION END *********************** */

/***************** Get Dashboard Savind And FD Details *******************/
export const getDashboardSavingsAndFDStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_SAVINGS_FD_START,
	payload: getData,
});

export const getDashboardSavingsAndFDSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_SAVINGS_FD_SUCCESS,
	payload: successData,
});

export const getDashboardSavingsAndFDFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_SAVINGS_FD_FAILURE,
	payload: failureData,
});

export const getDashboardSavingsAndFDReset = () => ({
	type: DashboardTypes.GET_DASHBOARD_SAVINGS_FD_RESET,
});

export const getDashboardSavingsAndFDChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_SAVINGS_FD_CHANGED,
});
/*********** Get Dashboard Savind And FD Details ***************/

/***************** Get Dashboard Total Branch Member *******************/
export const getDashboardTotalBranchMemberStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_START,
	payload: getData,
});

export const getDashboardTotalBranchMemberSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_SUCCESS,
	payload: successData,
});

export const getDashboardTotalBranchMemberFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_FAILURE,
	payload: failureData,
});

export const getDashboardTotalBranchMemberReset = () => ({
	type: DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_RESET,
});

export const getDashboardTotalBranchMemberChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_TOTAL_BRANCH_MEMBER_CHANGED,
});
/*********** Get Dashboard Total Branch Member ***************/

/***************** Get Branch Total Investment Amount *******************/
export const getBranchTotalInvestmentAmountStart = (getData: any) => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_START,
	payload: getData,
});

export const getBranchTotalInvestmentAmountSuccess = (successData: any) => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_SUCCESS,
	payload: successData,
});

export const getBranchTotalInvestmentAmountFailure = (failureData: any) => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_FAILURE,
	payload: failureData,
});

export const getBranchTotalInvestmentAmountReset = () => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_RESET,
});

export const getBranchTotalInvestmentAmountChanged = () => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_INVESTMENT_AMOUNT_CHANGED,
});
/*********** Get Branch Total Investment Amount ***************/

/***************** Get Branch Total OLB Amount *******************/
export const getBranchTotalOLBAmountStart = (getData: any) => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_START,
	payload: getData,
});

export const getBranchTotalOLBAmountSuccess = (successData: any) => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_SUCCESS,
	payload: successData,
});

export const getBranchTotalOLBAmountFailure = (failureData: any) => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_FAILURE,
	payload: failureData,
});

export const getBranchTotalOLBAmountReset = () => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_RESET,
});

export const getBranchTotalOLBAmountChanged = () => ({
	type: DashboardTypes.GET_BRANCH_TOTAL_OLB_AMOUNT_CHANGED,
});
/*********** Get Branch Total OLB Amount ***************/

/***************** Get Total Collection *******************/
export const getTotalCollectionStart = (getData: any) => ({
	type: DashboardTypes.GET_TOTAL_COLLECTION_START,
	payload: getData,
});

export const getTotalCollectionSuccess = (successData: any) => ({
	type: DashboardTypes.GET_TOTAL_COLLECTION_SUCCESS,
	payload: successData,
});

export const getTotalCollectionFailure = (failureData: any) => ({
	type: DashboardTypes.GET_TOTAL_COLLECTION_FAILURE,
	payload: failureData,
});

export const getTotalCollectionReset = () => ({
	type: DashboardTypes.GET_TOTAL_COLLECTION_RESET,
});

export const getTotalCollectionChanged = () => ({
	type: DashboardTypes.GET_TOTAL_COLLECTION_CHANGED,
});
/*********** Get Total Collection ***************/

/*********** Get Dashboard Amount Based on location ***************/
export const getDashboardAmountBasedonlocationStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_START,
	payload: getData,
});

export const getDashboardAmountBasedonlocationSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_SUCCESS,
	payload: successData,
});

export const getDashboardAmountBasedonlocationFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_FAILURE,
	payload: failureData,
});

export const getDashboardAmountBasedonlocationReset = () => ({
	type: DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_RESET,
});

export const getDashboardAmountBasedonlocationChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_AMOUNT_BASED_ON_LOCATION_CHANGED,
});
/*********** Get Dashboard Amount Based on location ***************/

/*********** Get Dashboard Zero Collection Details ***************/
export const getDashboardZeroCollectionDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_START,
	payload: getData,
});

export const getDashboardZeroCollectionDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_SUCCESS,
	payload: successData,
});

export const getDashboardZeroCollectionDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_FAILURE,
	payload: failureData,
});

export const getDashboardZeroCollectionDetailsReset = () => ({
	type: DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_RESET,
});

export const getDashboardZeroCollectionDetailsChanged = () => ({
	type: DashboardTypes.GET_DASHBOARD_ZERO_COLLECTION_DETAILS_CHANGED,
});
/*********** Get Dashboard Zero Collection Details ***************/

/*********** Get Online Staff Details ***************/
export const getOnlineStaffDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_ONLINE_STAFF_DETAILS_START,
	payload: getData,
});

export const getOnlineStaffDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_ONLINE_STAFF_DETAILS_SUCCESS,
	payload: successData,
});

export const getOnlineStaffDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_ONLINE_STAFF_DETAILS_FAILURE,
	payload: failureData,
});

export const getOnlineStaffDetailsReset = () => ({
	type: DashboardTypes.GET_ONLINE_STAFF_DETAILS_RESET,
});

export const getOnlineStaffDetailsChanged = () => ({
	type: DashboardTypes.GET_ONLINE_STAFF_DETAILS_CHANGED,
});
/*********** Get Online Staff Details ***************/

/*********** Get Officer Live Status ***************/
export const getOfficerLiveStatusStart = (getData: any) => ({
	type: DashboardTypes.GET_OFFICER_LIVE_STATUS_START,
	payload: getData,
});

export const getOfficerLiveStatusSuccess = (successData: any) => ({
	type: DashboardTypes.GET_OFFICER_LIVE_STATUS_SUCCESS,
	payload: successData,
});

export const getOfficerLiveStatusFailure = (failureData: any) => ({
	type: DashboardTypes.GET_OFFICER_LIVE_STATUS_FAILURE,
	payload: failureData,
});

export const getOfficerLiveStatusReset = () => ({
	type: DashboardTypes.GET_OFFICER_LIVE_STATUS_RESET,
});

export const getOfficerLiveStatusChanged = () => ({
	type: DashboardTypes.GET_OFFICER_LIVE_STATUS_CHANGED,
});
/*********** Get Officer Live Status ***************/

/** ***************** GET GOLD LOAN CARD DETAILS START *********************** */
export const getGoldLoanCardDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_START,
	payload: getData,
});

export const getGoldLoanCardDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_SUCCESS,
	payload: successData,
});

export const getGoldLoanCardDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_FAILURE,
	payload: failureData,
});

export const getGoldLoanCardDetailsResponseResetStart = () => ({
	type: DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_RESPONSE_RESET,
});

export const getGoldLoanCardDetailsResponseChanged = () => ({
	type: DashboardTypes.GET_GOLD_LOAN_CARD_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN CARD DETAILS END *********************** */

/** ***************** GET GOLD LOAN DASHBOARD LOAN DETAILS START *********************** */
export const getGoldLoanDashboardLoanDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_START,
	payload: getData,
});

export const getGoldLoanDashboardLoanDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_SUCCESS,
	payload: successData,
});

export const getGoldLoanDashboardLoanDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_FAILURE,
	payload: failureData,
});

export const getGoldLoanDashboardLoanDetailsResponseResetStart = () => ({
	type: DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_RESPONSE_RESET,
});

export const getGoldLoanDashboardLoanDetailsResponseChanged = () => ({
	type: DashboardTypes.GET_GOLD_LOAN_DASHBOARD_LOAN_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN DASHBOARD LOAN DETAILS END *********************** */

/** ***************** GET GOLD LOAN LOAN INDEX DETAILS START *********************** */
export const getGoldLoanLoanIndexDetailsStart = (getData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_START,
	payload: getData,
});

export const getGoldLoanLoanIndexDetailsSuccess = (successData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_SUCCESS,
	payload: successData,
});

export const getGoldLoanLoanIndexDetailsFailure = (failureData: any) => ({
	type: DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_FAILURE,
	payload: failureData,
});

export const getGoldLoanLoanIndexDetailsResponseResetStart = () => ({
	type: DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_RESPONSE_RESET,
});

export const getGoldLoanLoanIndexDetailsResponseChanged = () => ({
	type: DashboardTypes.GET_GOLD_LOAN_LOAN_INDEX_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN LOAN INDEX DETAILS END *********************** */
